import {AuthoringExamModelV1} from 'resources/GeneratedModels/AuthoringExam/AuthoringExamModel.v1';
import {examExtensions} from './exam.extensions';
import {authoringExamExtensions} from './authoringExam.extensions';

AuthoringExamModelV1.extend(examExtensions, authoringExamExtensions);

export {AuthoringExamModelV1};
